import { useEffect, useState } from "react";

const useMobile = (size: number) => {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < size);

  useEffect(() => {
    const handleResize = () => {
      const currentlyMobile = window.innerWidth < size;
      setIsMobile(currentlyMobile);
    };

    window.addEventListener("resize", handleResize);
    // Initial check
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, [size]);

  return isMobile;
};

export default useMobile;
